// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"4a19a69b","709":"9432723e","787":"3bc54eeb"}[chunkId] + ".chunk.js";
};